import { memo, useContext } from 'react';
import {
    CTable,
    CTableDataCell,
    CTableRow,
    CTableHeaderCell,
    CTableHead,
    CTableBody,
    CAvatar
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { ENV, ROLES } from '../utils/constants';
import avatar from '../assets/images/generic-avatar.png';
import { AuthContext } from '../store/auth';

const TestimonialTable = ({ testimonials }) => {
    const navigate = useNavigate();

    const { user } = useContext(AuthContext);

    const clickHandler = id => {
        if ([ROLES.admin, ROLES.super].includes(user.roles)) {
            navigate(`/dashboard/testimonials/${id}`);
        }
    };

    return (
        <CTable hover striped responsive='sm'>
            <CTableHead>
                <CTableRow>
                    <CTableHeaderCell>#</CTableHeaderCell>
                    <CTableHeaderCell>First Name</CTableHeaderCell>
                    <CTableHeaderCell>Last Name</CTableHeaderCell>
                    <CTableHeaderCell>Content</CTableHeaderCell>
                    <CTableHeaderCell>Status</CTableHeaderCell>
                    <CTableHeaderCell>Membership</CTableHeaderCell>
                    <CTableHeaderCell>Avatar</CTableHeaderCell>
                </CTableRow>
            </CTableHead>
            <CTableBody>
                {testimonials &&
                    testimonials.map(testimonial => (
                        <CTableRow
                            role='button'
                            key={testimonial.id}
                            onClick={() => clickHandler(testimonial.id)}
                        >
                            <CTableDataCell>{testimonial.count}</CTableDataCell>
                            <CTableDataCell>
                                {testimonial.firstName}
                            </CTableDataCell>
                            <CTableDataCell>
                                {testimonial.lastName}
                            </CTableDataCell>
                            <CTableDataCell>
                                {`${testimonial.content.substring(0, 30)}...`}
                            </CTableDataCell>
                            <CTableDataCell>
                                {testimonial.status}
                            </CTableDataCell>
                            <CTableDataCell>
                                {testimonial.membership}
                            </CTableDataCell>
                            <CTableDataCell>
                                {testimonial.images.length > 0 ? (
                                    <CAvatar
                                        size='md'
                                        src={`${ENV.images}/${testimonial.images[0].url}`}
                                    />
                                ) : (
                                    <CAvatar size='md' src={`${avatar}`} />
                                )}
                            </CTableDataCell>
                        </CTableRow>
                    ))}
            </CTableBody>
        </CTable>
    );
};

export default memo(TestimonialTable);
